import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const COURSES_STORE_NAME = 'courses'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
